import { RelationshipAttributePermissionRuleCoreBase } from "./relationship-attribute-permission-rule.core.base"


export class RelationshipAttributePermissionRuleCore extends RelationshipAttributePermissionRuleCoreBase {

}